module.exports = __webpack_public_path__ + "static/media/login.0d123e34.png";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/login.png
// module id = 1133
// module chunks = 0